export const DEEPLINK_JOIN_NETWORK = '/s/network/join/' // + token
export const DEEPLINK_JOIN_MY_SPACE = '/s/myspace/join/' // + token
